import { render, staticRenderFns } from "./NewArticle.vue?vue&type=template&id=228e3800&"
import script from "./NewArticle.vue?vue&type=script&lang=js&"
export * from "./NewArticle.vue?vue&type=script&lang=js&"
import style0 from "./NewArticle.vue?vue&type=style&index=0&id=228e3800&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports